/* eslint @typescript-eslint/naming-convention: 0 */

import type { ReservationSectionId } from '@/wabunka-src/common/features/Reservation/core/requiredFields/sections';

type ReservationSectionGaValue = 's1' | 's2' | 's3' | 's4';

// 値は Design Doc の S1〜S4 に揃え、コード上のセクション ID を改名しても集計が切れないようにする
const RESERVATION_SECTION_GA_VALUES: Record<ReservationSectionId, ReservationSectionGaValue> = {
  contactInfo: 's1',
  additionalOptions: 's2',
  hostDetails: 's3',
  payment: 's4',
};

export interface ReservationSectionParams {
  reservation_section: ReservationSectionGaValue;
}

export const buildReservationSectionParams = (sectionId: ReservationSectionId): ReservationSectionParams => ({ reservation_section: RESERVATION_SECTION_GA_VALUES[sectionId] });
